import React from 'react'

const Contact = () => {
  return (
    <div>Conatact Us</div>
  )
}

export default Contact